import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import LogoCC from '../../assets/images/logo-cc.svg';

const useStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.text.primary,
    textDecoration: 'none',
    display: 'inline-flex',
    gridGap: theme.spacing(2),
    marginBottom: theme.margin.bottom,
    '& img': {
      maxHeight: '42px',
    },
  },
  title: {
    fontFamily: '"Igra Sans", "montserrat", "Helvetica", "Arial", sans-serif',
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.3rem',
      lineHeight: '1.8rem',
    },
  },
  [theme.breakpoints.up('sm')]: {
    root: {
      '& img': {
        maxHeight: '50px',
      },
    },
  },
  [theme.breakpoints.up('md')]: {
    root: {
      '& img': {
        maxHeight: '70px',
      },
    },
  },
  small: {
    '& img': {
      [theme.breakpoints.up('md')]: {
        maxHeight: '50px',
      },
    },
    '& h3': {
      [theme.breakpoints.up('xs')]: {
        fontSize: '1.3rem',
        lineHeight: '1.8rem',
      },
    },
  },
}));

const CoordinationCouncilLogo = ({ color, small }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const h3 = (
    <Typography
      component="h3"
      variant="h3"
      color={color}
      align="left"
      className={classes.title}
    >
      {t('coordination_council_1')}
      <br />
      {t('coordination_council_2')}
    </Typography>
  );

  return (
    <a
      href="https://rada.vision/"
      target="_blank"
      rel="noopener noreferrer"
      className={clsx(classes.root, { [classes.small]: small })}
    >
      <img
        src={LogoCC}
        alt={t('coordination_council_logo_alt')}
      />
      {h3}
    </a>
  );
};

CoordinationCouncilLogo.defaultProps = {
  color: 'inherit',
  small: false,
};

CoordinationCouncilLogo.propTypes = {
  color: PropTypes.string,
  small: PropTypes.bool,
};

export default CoordinationCouncilLogo;
